
import Vue from "vue";
import { setAccessToken } from "@/api";
import { getWebsiteListByCompanyId } from "@/api/websites-new";
import { EnterpriseAdapterApi } from "@vacancorp/enterprise.adapter.api.vacanservice.com";

import { Website } from "@/models";

import WebsiteList from "./components/WebsiteList.vue";
import SearchForm from "@/components/BaseSearchForm.vue";
import Pager from "@/components/BasePager.vue";
import TheTemplate from "../TheTemplate.vue";

export type FilterCondition = {
  word?: string;
};

export type DataType = {
  websites: Array<Website>;
  filterCondition: FilterCondition;
  totalPage: number;
  currentPage: number;
};

export default Vue.extend({
  name: "WebsiteListScreen",

  data(): DataType {
    return {
      websites: [],
      filterCondition: {
        word: "",
      },
      totalPage: 0,
      currentPage: 0,
    };
  },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin";
    },
  },

  mounted() {
    this.fetchWebsites();
  },

  watch: {
    $route(to, _) {
      if (to.params.updated === "true") {
        this.fetchWebsites(this.currentPage);
      }
    },
  },

  components: {
    TheTemplate,
    SearchForm,
    WebsiteList,
    Pager,
  },

  methods: {
    async fetchWebsites(page?: number): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const filterString: string = JSON.stringify({
        q: this.filterCondition.word,
      });
      setAccessToken(this.$auth.accessToken);

      const response: EnterpriseAdapterApi.ResponseGetWebsiteList = await getWebsiteListByCompanyId(
        companyId,
        filterString,
        page,
      );

      this.websites = response.websites;
      this.currentPage = response.currentPage;
      this.totalPage = response.totalPage;
    },

    updateFilterCondition(condition?: FilterCondition): void {
      this.filterCondition = Object.assign(this.filterCondition, condition);
    },

    changePage(page: number): void {
      this.fetchWebsites(page);
    },
  },
});
